export default function AdminToggle({ on, onChange, colorOn, label }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
      <button
        type="button"
        onClick={onChange}
        aria-pressed={on}
        style={{
          width: 44,
          height: 24,
          borderRadius: 12,
          border: 'none',
          background: on ? (colorOn || 'var(--teal)') : '#ccc',
          position: 'relative',
          transition: 'background .2s',
          flexShrink: 0,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 2,
            left: on ? 22 : 2,
            width: 20,
            height: 20,
            borderRadius: '50%',
            background: 'white',
            transition: 'left .2s',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
          }}
        />
      </button>
      {label && (
        <span style={{ fontSize: 'var(--text-label-medium-size)', lineHeight: 'var(--text-label-medium-line)', color: 'var(--gray)', textAlign: 'center' }}>{label}</span>
      )}
    </div>
  );
}
